const blogsData = [
    {
        id: 1,
        img: "https://cdn.pixabay.com/photo/2016/04/20/08/21/entrepreneur-1340649_960_720.jpg",
        date: "July 15, 2022",
        category: "Business Help",
        title: "Successful Business Growth With Help From Consultants",
        post: "Growing a business is not an easy task. Much goes into business growth. Depending on the type of business, growing a business includes many tasks that must be executed successfully.",
    },
    {
        id: 2,
        img: "https://cdn.pixabay.com/photo/2017/09/07/08/54/money-2724241_960_720.jpg",
        date: "August 04, 2022",
        category: "Finance Consulting",
        title: "Starting A New Business? Need Business Help?",
        post: "Are you considering starting a new business? Why not get the assistance of a professional expert? Business consultants work with clients on a wide range of business objectives.",
    },
    {
        id: 3,
        img: "https://cdn.pixabay.com/photo/2018/03/10/12/00/teamwork-3213924_960_720.jpg",
        date: "May 05, 2022",
        category: "Consulting Services",
        title: "Get Business Help Through Business Consulting Services",
        post: "Are you trying to start a business? You may want to talk to a business consultant. Business consulting services assist startup companies and established businesses of any size.",
    },
    {
        id: 4,
        img: "https://cdn.pixabay.com/photo/2016/10/09/08/32/digital-marketing-1725340_960_720.jpg",
        date: "January 01, 2022",
        category: "Sales Consulting",
        title: "Grow Market Share Through Marketing Consulting Services",
        post: "Startup companies and existing businesses have the same goal to grow market share and of course profits through it. These goals tend to be primary for a for profit business.",
    },
    {
        id: 5,
        img: "https://cdn.pixabay.com/photo/2016/11/27/21/42/stock-1863880_960_720.jpg",
        date: "December 15, 2021",
        category: "Marketing Consulting",
        title: "Improve Ecommerce Sales Through Business Consultancy",
        post: "Do you need to improve your ecommerce sales? It is very common for brands and companies to work on improving their online sales by ongoing effort & how to go about it.",
    },
    {
        id: 6,
        img: "https://cdn.pixabay.com/photo/2017/08/30/07/56/money-2696229_960_720.jpg",
        date: "August 05, 2021",
        category: "Finance Consulting",
        title: "3 Time Management Hacks For Business Growth",
        post: "Time management improves the efficiency of a business, and business owners should continuously work on improving their own time management skills.",
    },
    {
        id: 7,
        img: "https://cdn.pixabay.com/photo/2018/09/17/12/46/business-idea-3683781_960_720.jpg",
        date: "June 10, 2021",
        category: "Marketing Consulting",
        title: "Have You Considered Marketing Consulting?",
        post: "Marketing has become much more complex with the arrival of the digital age. Certainly, since the Internet has been around, marketing and advertising started to change.",
    },
    {
        id: 8,
        img: "https://cdn.pixabay.com/photo/2016/04/30/00/28/dollar-1362244_960_720.jpg",
        date: "April 28, 2021",
        category: "Finance Consulting",
        title: "Avoid Costly Business Mistakes Through Business Consultancy",
        post: "Get professional help with your business and avoid costly business mistakes. Entrepreneurs and established companies look to start and grow their business.",
    },
    {
        id: 9,
        img: "https://cdn.pixabay.com/photo/2014/12/08/21/25/business-561387_960_720.jpg",
        date: "February 11, 2021",
        category: "Business Help",
        title: "Stuck In Business? Need Help To Create Business Momentum?",
        post: "Business if fascinating! Successful companies can go under fast. A business almost gone can return successfully and dominate in the market. Business is fascinating like that.",
    },
    {
        id: 10,
        img: "https://cdn.pixabay.com/photo/2017/01/05/00/15/chart-1953616_960_720.jpg",
        date: "October 02, 2020",
        category: "Business Consulting",
        title: "Boost Online Sales With Professional Help",
        post: "Do you want to increase your online sales? If yes, have you considered working with professional help to get this properly done?",
    },
    {
        id: 11,
        img: "https://cdn.pixabay.com/photo/2014/10/16/20/08/income-tax-491626_960_720.jpg",
        date: "August 11, 2020",
        category: "Retail Business",
        title: "Get Retail Business Help To Start And Grow Successfully",
        post: "Getting a retail business started is not an easy task. Growing a retail business successfully is just as difficult. Either job is challenging.",
    },
    {
        id: 12,
        img: "https://cdn.pixabay.com/photo/2015/11/26/07/47/hands-1063442_960_720.jpg",
        date: "May 15, 2020",
        category: "Business Help",
        title: "Business Problems Can Be Resolved With Professional Help",
        post: "Similar to legal attorneys helping investors and entrepreneurs with the law, business consultants help clients with their business.",
    },
];

export default blogsData;